"use client";

import { c as _c } from "react/compiler-runtime";
import WaveDropDeleteButton from "@/components/utils/button/WaveDropDeleteButton";
import VotingModal from "@/components/voting/VotingModal";
import { useVotingModalState } from "@/components/voting/useVotingModalState";
import { ApiDropType } from "@/generated/models/ApiDropType";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import { SingleWaveDropContent } from "./SingleWaveDropContent";
import { SingleWaveDropInfoContainer } from "./SingleWaveDropInfoContainer";
import { SingleWaveDropInfoDetails } from "./SingleWaveDropInfoDetails";
import { WaveDropMetaRow } from "./WaveDropMetaRow";
import { WaveDropVoteSummary } from "./WaveDropVoteSummary";
interface SingleWaveDropInfoPanelProps {
  readonly drop: ExtendedDrop;
  readonly isVotingClosed?: boolean | undefined;
  readonly isVotingControlsLocked?: boolean | undefined;
  readonly winningThreshold?: number | null | undefined;
}
export const SingleWaveDropInfoPanel = t0 => {
  const $ = _c(33);
  const {
    drop,
    isVotingClosed: t1,
    isVotingControlsLocked: t2,
    winningThreshold
  } = t0;
  const isVotingClosed = t1 === undefined ? false : t1;
  const isVotingControlsLocked = t2 === undefined ? false : t2;
  const {
    canDelete,
    canShowVote,
    isVotingEnded,
    isWinner
  } = useDropInteractionRules(drop);
  const isChatWave = drop.drop_type === ApiDropType.Chat;
  const isVotingActionLocked = isVotingClosed || isVotingControlsLocked;
  const {
    isOpen: isVotingOpen,
    open: openVoting,
    close: closeVoting
  } = useVotingModalState(isVotingActionLocked);
  const canShowVotingAction = canShowVote && !isVotingActionLocked;
  const shouldShowVotingEndedSummary = isVotingEnded || isVotingClosed;
  let t3;
  if ($[0] !== drop) {
    t3 = <div className="tw-mb-6"><SingleWaveDropContent drop={drop} /></div>;
    $[0] = drop;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== canShowVotingAction || $[3] !== drop || $[4] !== isChatWave || $[5] !== isWinner || $[6] !== openVoting || $[7] !== shouldShowVotingEndedSummary || $[8] !== winningThreshold) {
    t4 = !isChatWave && <div className="tw-mb-6 tw-flex tw-justify-center"><WaveDropVoteSummary drop={drop} isWinner={isWinner} isVotingEnded={shouldShowVotingEndedSummary} canShowVote={canShowVotingAction} onVoteClick={openVoting} winningThreshold={winningThreshold} /></div>;
    $[2] = canShowVotingAction;
    $[3] = drop;
    $[4] = isChatWave;
    $[5] = isWinner;
    $[6] = openVoting;
    $[7] = shouldShowVotingEndedSummary;
    $[8] = winningThreshold;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== drop || $[11] !== isWinner) {
    t5 = <WaveDropMetaRow drop={drop} isWinner={isWinner} />;
    $[10] = drop;
    $[11] = isWinner;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== drop || $[14] !== isChatWave) {
    t6 = !isChatWave && <div className="tw-mt-6"><SingleWaveDropInfoDetails drop={drop} /></div>;
    $[13] = drop;
    $[14] = isChatWave;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== canDelete || $[17] !== drop) {
    t7 = canDelete && drop.drop_type !== ApiDropType.Winner && <div className="tw-w-full tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-800 tw-pb-6 tw-pt-6"><WaveDropDeleteButton drop={drop} /></div>;
    $[16] = canDelete;
    $[17] = drop;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t7) {
    t8 = <SingleWaveDropInfoContainer><div className="tw-px-4 tw-pb-8 @[640px]:tw-px-8 @[640px]:tw-pb-10"><div className="tw-mx-auto tw-max-w-3xl">{t3}{t4}{t5}{t6}{t7}</div></div></SingleWaveDropInfoContainer>;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== closeVoting || $[26] !== drop || $[27] !== isChatWave || $[28] !== isVotingOpen) {
    t9 = !isChatWave && <VotingModal drop={drop} isOpen={isVotingOpen} onClose={closeVoting} />;
    $[25] = closeVoting;
    $[26] = drop;
    $[27] = isChatWave;
    $[28] = isVotingOpen;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== t8 || $[31] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[30] = t8;
    $[31] = t9;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  return t10;
};